import CommonService from '../../../../services/commonService';
import React from 'react';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeFourHeader = ({ history, operator, loginData, t, onMyAccountClick }) => {
	let url = window.location.href;
	let baseURL = window.location.origin;
	return (
		operator && (
			<div className="themes-theme-four-header">
				<div
					style={{
						background: operator && operator.color_codes && operator.color_codes.header_color,
						color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
						height: 110,
					}}
					className="d-flex-c "
				>
					<style>
						.themes-theme-four-header .acitve:hover {'{'}
						background:
						{operator && operator.color_codes && operator.color_codes.tertiary_color
							? operator.color_codes.tertiary_color
							: ''}
						{'}'}
						.nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
						{/* margin-top:260px */}
						{operator && operator.operator_name === 'chilebus' && url.includes('chilebus-destinos') || url.includes('chilebus-office') || url.includes('about-chilebus') || url.includes('about-chilebus') || url.includes('chilebus-terms') || (url === baseURL + '/') || url.includes('chilebus-contact') ? 'margin-top:170px' : 'margin-top:280px'}


						{'}'}
						.nav-section.home-nav-section.common-top-strip.header-box.payments-page-header + * {'{'}
						{/* margin-top:155px */}
						margin-top:168px !important
						{'}'}
					</style>
					<div className="new-container top-strip">
						<div>&nbsp;</div>
						<div>
							<a href="/">
								<img
									src={operator && operator.header_logo ? operator.header_logo : ''}
									alt=""
									className="logo-saopaulo"
									style={{
										height: 'auto',
										width:
											operator && operator.header_logo_width ? operator.header_logo_width : 'auto',
										paddingLeft: 28,
										marginLeft: operator && operator.operator_name === 'santajuana' || operator && operator.operator_name === 'chilebus' ? 145 : 0,
									}}
								/>
							</a>
						</div>
						<div className="phone-conatct pointer">


							{operator.phone_number ? (
								<div>
									{operator && operator.operator_name === "santajuana" ?
										(<img
											src={getIcons('whatsapp', operator)}
											alt=""
											className="icon"
											style={{ width: '20px', height: '20px' }}
										/>) :
										(
											<img
												src={getIcons('phone', operator)}
												alt=""
												className="icon"
												style={{ width: '20px', height: '20px' }}
											/>
										)}

									<span>{operator.phone_number}</span>
								</div>


							) : null}


							{operator && operator.has_user_account && (
								<div style={{ marginLeft: '10px' }}>
									<div className="my-account-top font10">
										<a onClick={onMyAccountClick}>
											{CommonService.isLoggedIn(loginData) && loginData.image_link ? (
												<div className="dp-image-top">
													<img src={loginData.image_link} alt="DIS" />
												</div>
											) : (
												<div
													className={
														'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
													}
												>
													<img
														src={getIcons('userIcon', operator)}
														// src="/static/images/user_red_dot.svg"
														alt={t('TRANSLATIONS.USER_DOT')}
													/>
												</div>
											)}
											{/* {CommonService.isLoggedIn(this.props.common.loginData)
                      ? CommonService.capitalize(this.props.common.loginData.name)
                      : t('HOME.MY_ACCOUNT')} */}
										</a>
										{/* {this.state.showMyAccountDropDown ? this.renderMyAccountDropdown(t) : null} */}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>

				<div
					// style={{
					//   background: operator && operator.color_codes && operator.color_codes.sub_footer_color,
					//   color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
					// }}

					style={{
						background: operator.operator_name === 'santajuana' ?
							(operator && operator.color_codes && operator.color_codes.button_color) :
							(operator && operator.color_codes && operator.color_codes.sub_footer_color),
						color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
					}}
				>
					<div className="new-container nav-links">
						{operator &&
							operator.header_links &&
							operator.header_links.length > 0 &&
							operator.header_links.map((val, i) => {
								return (
									<span
										className={`nav-item acitve pointer  ${window.location.pathname ==
											Object.values(val) && 'bold-text'} `}
										style={{
											background:
												window.location.pathname == Object.values(val) &&
													operator &&
													operator.color_codes &&
													operator.color_codes.tertiary_color
													? operator.color_codes.tertiary_color
													: '',

											borderRight: operator.header_links.length - 1 !== i ? '1px solid white' : '',
										}}
										onClick={() => {
											history.push(Object.values(val)[0]);
										}}
									>
										{Object.keys(val)}
									</span>
								);
							})}


					</div>
				</div>
			</div>
		)
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
	};
}

/* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch)
//   };
// }

export default connect(mapStateToProps, {})(ThemeFourHeader);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourHeader.js